const SignUpsCardStyles = {
  // Main card styles
  mainCard: {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    borderRadius: "12px",
    border: "1px solid #f0f0f0",
  },
  
  mainCardHead: {
    borderBottom: "1px solid #f0f0f0",
    fontSize: "16px",
    fontWeight: 600,
    color: "#262626",
  },

  // Tag styles
  tag: {
    width: "100%"
  },

  // Code block card styles
  codeCard: {
    backgroundColor: "#fafafa",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
  }
};

export default SignUpsCardStyles;